import React, { useEffect, useState } from "react";

import { ITariffPlan, ITariffPlanPrice } from "@eagerdog/interfaces";
import { BillingPeriod } from "@eagerdog/constants";

import { apiService } from "src/services";
import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Button from "src/components/Button/Button";
import LoadingSpinner from "src/components/LoadingSpinner";
import { toast } from "src/components/Toast/ToastManager";

import styles from "./SubscriptionChangeForm.module.scss";

interface IProps {
  submitting?: boolean
  onSubmit: (price: ITariffPlanPrice) => void
}

const SubscriptionChangeForm: React.FC<IProps> = ({ submitting, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [tariffPlans, setTariffPlans] = useState<ITariffPlan[]>([]);
  const [billingPeriod, setBillingPeriod] = useState<IOption>(
    { id: BillingPeriod.YEARLY, value: "Annual" }
  );

  useEffect(() => {
    apiService.getTariffPlans()
      .then((response) => {
        setTariffPlans(response);
      })
      .catch(() => {
        toast.show({
          title: "Subscription",
          content: "Could not load subscription, please try again later",
          duration: 5000,
          type: "fail"
        });
      })
  }, []);

  const getBillingPeriodOptions = (): IOption[] => {
    return [
      { id: BillingPeriod.YEARLY, value: "Annual" },
      { id: BillingPeriod.MONTHLY, value: "Monthly" },
    ];
  }

  const formatPrice = () => {
    const price = proPlan?.prices.find((p) => p.billing_period === billingPeriod.id);

    if (price) {
      const formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: price.currency,
        minimumFractionDigits: 2,
      });
      const period = price.billing_period;

      return [formatter.format(price.amount_cents / 100), "/", period].join(" ");
    }
  }

  if (loading) {
    return <LoadingSpinner/>;
  }

  const proPlan = tariffPlans.find((p) => p.type === "pro");
  const price = proPlan?.prices.find((p) => p.billing_period === billingPeriod.id);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Upgrade to Pro</h3>
      <Dropdown
        className={styles.billingOptions}
        value={billingPeriod}
        label="Billing Period"
        onChange={(_e, value: IOption) => setBillingPeriod(value)}
        options={getBillingPeriodOptions()}
        placeholder="Select billing period"
      />
      {!!price && <h4>
        {`Price will be ${formatPrice()}`}
      </h4>}
      <Button
        onClick={() => {
          if (price) onSubmit(price);
        }}
      >
        Upgrade
      </Button>
    </div>
  )
}

export { SubscriptionChangeForm }
